import * as React from 'react';
import styled from 'styled-components';

import { IDesktopMenuElementsProps } from './menytypes';
import { MenuContext } from '.';
import { NavIcon } from './nav-icon';
import { useSpring, animated } from 'react-spring';
import { SearchInput } from './search-input';
import { useLocation, useParams } from 'react-router';
import { Link } from 'react-router-dom';

export const DesktopMenuElements = (props: IDesktopMenuElementsProps) => {
  const params = useParams<any>();
  const location = useLocation();
  const context = React.useContext(MenuContext);

  const clickSearch = (e: any) => {
    e.preventDefault();
    context.setMenuState({
      ...context.menuState,
      searchVisible: !context.menuState.searchVisible,
      modalVisible: false,
    });
  };

  const fadeIn: any = useSpring({
    float: 'left',
    transitionTimingFunction: 'ease-in-out',
    opacity: context.menuState.modalVisible ? 0 : 1,
  });

  return (
    <DesktopMenuWrap>
      {context.menuState.searchVisible ? (
        <SearchInput history={props.history} />
      ) : (
        <>
          {props.vistopp !== false && (
            <animated.div style={fadeIn}>
              <MenuUl className="large-menu">
                {props.menuelements?.map((item: any, index: number) => {
                  if (item.relative) {
                    return (
                      <li key={`menu_item_${index}`}>
                        <Link to={item.link}>{item.name}</Link>
                      </li>
                    );
                  }
                  return (
                    <li key={`menu_item_${index}`}>
                      <a href={item.link}>{item.name}</a>
                    </li>
                  );
                })}
              </MenuUl>
            </animated.div>
          )}

          <MenuRightElements className="menu-search-icon">
            <a onClick={clickSearch} href="">
              <svg
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M29.7224 27.2685L20.605 18.1494C22.0073 16.3081 22.7964 13.9408 22.7964 11.3976C22.7964 5.08477 17.7116 0 11.3988 0C5.08597 0 -0.000488281 5.08645 -0.000488281 11.3993C-0.000488281 17.7121 5.08428 22.7969 11.3971 22.7969C13.9403 22.7969 16.2188 22.0078 18.1489 20.6055L27.268 29.7246C27.6181 30.0747 28.0571 30.2506 28.496 30.2506C28.935 30.2506 29.3722 30.0747 29.7241 29.7246C30.4244 29.0226 30.4244 27.9704 29.7224 27.2685L29.7224 27.2685ZM11.3988 19.2903C7.01432 19.2903 3.50776 15.7837 3.50776 11.3993C3.50776 7.01481 7.01432 3.50825 11.3988 3.50825C15.7833 3.50825 19.2898 7.01481 19.2898 11.3993C19.2898 15.7821 15.7816 19.2903 11.3988 19.2903Z"
                  fill=""
                ></path>
              </svg>
            </a>
          </MenuRightElements>
        </>
      )}
      <div
        className="menu-hamburger-icon"
        style={{ float: 'right', top: '3px', position: 'relative' }}
      >
        <NavIcon />
      </div>
    </DesktopMenuWrap>
  );
};

const DesktopMenuWrap = styled.div`
  display: flex;
  align-items: center;

  svg {
    fill: #fff;
    width: 18px;
    height: 23px;
  }
`;

const MenuUl = styled.ul`
  font-size: 18px;
  color: #fff;
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
  float: left;
  display: none;

  li {
    display: inline-block;
    margin: 0;
    padding: 0;
    margin-right: 30px;
  }
  a {
    color: inherit;
    text-decoration: inherit;
  }

  @media (min-width: 1140px) {
    display: block;
  }
`;

const MenuRightElements = styled.div`
  position: relative;
  top: 2px;
  color: #fff;
  font-size: 18px;
  list-style: none;
  margin: 0 15px 0 0;
  padding: 0;
  float: left;

  /*
  li {
    display: inline-block;
    margin: 0;
    margin-right: 30px;
    padding: 0;
    &:last-child {
      margin-right: 0;
    }
  }
  */

  a {
    color: inherit;
    text-decoration: inherit;
  }

  svg {
    margin: 0px 5px 0 0;
    vertical-align: -3px;
  }
`;
